import { defineMessages } from "react-intl"

export default defineMessages({
  starterTitle: {
    id: "sign.title.required",
    defaultMessage: "Electronic signature required"
  },
  starterMainInfo: {
    id: "sign.starter.maininfo",
    defaultMessage: "Le formulaire {formName} nécessite votre signature."
  },
  starterSubInfo: {
    id: "sign.starter.subinfo",
    defaultMessage:
      "Afin de signer ce document, la signature électronique vous est proposée.\n" +
      "Nous allons vous rediriger vers la plateforme {docusign}, notre prestataire de confiance."
  },
  starterExplanation: {
    id: "sign.starter.explanation",
    defaultMessage:
      "Vous aurez alors le choix entre :\n{list}" +
      "Si toutefois vous décidez de décliner la signature, veuillez préciser\n" +
      "le cas échéant les raisons de ce refus."
  },
  signDocumentLater: {
    id: "sign.starter.sign.later",
    defaultMessage: "Consult form, and sign it later"
  },
  signDocument: {
    id: "sign.starter.sign.document",
    defaultMessage: "Consult form, and sign it"
  },
  declineDocument: {
    id: "sign.starter.decline.document",
    defaultMessage: "Decline to sign doument"
  },
  declineTitle: {
    id: "sign.decline.title",
    defaultMessage: "Electronic signature declined"
  },
  declineMainInfo: {
    id: "sign.decline.maininfo",
    defaultMessage: "Merci d'avoir consulté le formulaire {formName}."
  },
  declineSubInfo: {
    id: "sign.decline.subinfo",
    defaultMessage:
      "Cependant, vous n'avez pas souhaité le signer. Nous allons prendre\n" +
      "en compte vos remarques, et nous reviendrons vers vous\n" +
      "prochainement. Pour toute demande urgente, n'hesitez pas à nous\n" +
      "contacter."
  },
  completeTitle: {
    id: "sign.complete.title",
    defaultMessage: "Electronic signature completed"
  },
  completeMainInfo: {
    id: "sign.complete.maininfo",
    defaultMessage: "Merci d'avoir complété et signé le formulaire {formName}."
  },
  completeSubInfo: {
    id: "sign.complete.subinfo",
    defaultMessage:
      "Nous vous rappellons que les informations collectées auprès de nos\n" +
      "clients sont conservées, et utilisées dans le but d'être transmis à\n" +
      "l'Autorité des Marchés Financiers (AMF)."
  },
  callbackCanceledEventInfo: {
    id: "sign.callback.cancelled.info",
    defaultMessage: `{formName} document is still waiting for your signature, don't forget it.`
  },
  callbackExpiredEventTitle: {
    id: "sign.callback.expired.title",
    defaultMessage: "DocuSign® link expired"
  },
  callbackExpiredEventInfo: {
    id: "sign.callback.expired.info",
    defaultMessage:
      "Le temps alloué pour la signature du document a expiré (5min.), un" +
      " nouveau lien vient d'être généré afin de finaliser la signature."
  },
  callbackAccessEventTitle: {
    id: "sign.callback.access.title",
    defaultMessage: "Authentication failed"
  },
  callbackAccessEventInfo: {
    id: "sign.callback.access.info",
    defaultMessage:
      "Nous n'avons pas réussi à vous authentifier correctement auprès de la " +
      "plateforme DocuSign®, veuillez réessayer ultérieurement. Si toutefois le " +
      "problème persiste, que votre demande est importante, n'hésitez pas à " +
      "nous contacter."
  },
  callbackExceptionEventTitle: {
    id: "sign.callback.exception.title",
    defaultMessage: "Error on DocuSign® platform"
  },
  callbackExceptionEventInfo: {
    id: "sign.callback.exception.info",
    defaultMessage:
      "La cérémonie de signature n'a pu aboutir en raison d'une erreur interne à la plateforme."
  },
  continue: {
    id: "word.continue",
    defaultMessage: "Continue"
  },
  return: {
    id: "word.return",
    defaultMessage: "Return"
  },
  finish: {
    id: "word.finish",
    defaultMessage: "Terminate"
  }
})
